import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableVehicleTrackers from "./components/TableVehicleTrackers";

function VehicleTrackersPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableVehicleTrackers />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default VehicleTrackersPage